  <div class="row post-modal-tag-list-card mx-0 mb-2 p-2" id="divPostSuggcard">
    <div class="col-2 pr-0 pl-2 pt-1">
      <div class="position-relative card-40">
        <app-user-pofile-pic [profile_pic_image]="connection_pic_image"></app-user-pofile-pic>
      </div>
    </div>
    <div class="col-10 col-md-5 pl-lg-0 pr-lg-0">
      <p class="paragraph-bold">
        {{sugg?.full_name}}
        <br />
        <span class="secondary-paragraph" *ngFor="let SuggSpe of sugg?.specialities">
          <span class="color-grey-500">
            {{(SuggSpe?.is_primary==1) ? SuggSpe?.speciality_name: ''}}
          </span>
        </span>
      </p>
    </div>
    <div class="col-12 col-md-5 text-right px-0 pt-2" id="postConnectTag">
      <button type="button" [ngClass]="{'btn-disabled':checkVal(sugg)}"
        [eventTracker]='{"category":mls.googleEventText.create_post_tag.category,"action":mls.googleEventText.create_post_tag.key3,"product_type":"", "product_id":""}'
        (click)="addTagTo($event, sugg)"
        class="btn-design outline small h-auto">
        <img *ngIf="showTagProcessed==false" src="assets/themes/icons/connect-and-tag-icon.svg" alt="tag-icon">
        <span *ngIf="!checkVal(sugg)" id="connectTagRequest">
          {{mls?.languageText?.create_post_tag?.key7}}
          <span *ngIf="mls?.is_lskey_display==1">(create_post_tag?.key7)</span>
        </span>
        <span *ngIf="checkVal(sugg)"  id="connectTagRequestSpan">
          {{mls?.languageText?.create_post_tag?.key8}}
          <span *ngIf="mls?.is_lskey_display==1">(create_post_tag?.key8)</span>
        </span>
        <img *ngIf="finished " src="assets/themes/icons/primary-loader.gif" width="20" alt="loader">
      </button>
    </div>
  </div>